const leadModalTabs = {
  LEAD_DETAILS: 'LEAD_DETAILS',
  CONTRACT: 'CONTRACT',
  COACH_DETAILS: 'COACH_DETAILS',
  PROMOTIONS: 'PROMOTIONS',
  CHAT: 'CHAT',
  HISTORY: 'HISTORY',
};

export default leadModalTabs;
